export const levels = {
    10: 'TRC',
    20: 'DBG',
    30: 'INF',
    40: 'WRN',
    50: 'ERR',
    60: 'CRT',
} as const;

export function isKnownLevel(level: any): level is keyof typeof levels {
    return level in levels;
}
